import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	allProjectTypesSpork: {
		id: 'project-type-picker.all-project-types-spork',
		defaultMessage: 'Filter by product',
		description: 'Placeholder to help the user filter by product the projects list',
	},
	dynamicProjectNoTranslate: {
		id: 'project-type-picker.dynamic-project-no-translate',
		defaultMessage: 'Jira {name}',
		description: 'supports for unknown project types no translationNeeded',
	},
	softwareProjectSpork: {
		id: 'project-type-picker.software-project-spork',
		defaultMessage: 'Jira - software projects',
		description: 'Indicates that this project is a software project',
	},
	businessProjectSpork: {
		id: 'project-type-picker.business-project-spork',
		defaultMessage: 'Jira - business projects',
		description: 'Indicates that this project is a business project',
	},
	serviceDeskProject: {
		id: 'project-type-picker.service-desk-project',
		defaultMessage: 'Jira Service Management',
		description: 'Indicates that this project is a service desk project',
	},
});
